import { render, staticRenderFns } from "./ArrowRightSvg.vue?vue&type=template&id=00b2854d&scoped=true&"
import script from "./ArrowRightSvg.vue?vue&type=script&lang=js&"
export * from "./ArrowRightSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b2854d",
  null
  
)

export default component.exports